module.exports = __webpack_public_path__ + "static/media/home2.0d2df94e.png";